module.exports = __webpack_public_path__ + "images/softball1-2e60283d392248e60ffc4dc18246feb3.jpg";